export default function PaginationControls({ currentPage, totalPages, onPageChange, disabled }) {
  if (totalPages <= 1) return null;

  const prevDisabled = disabled || currentPage <= 1;
  const nextDisabled = disabled || currentPage >= totalPages;

  // Build page numbers with ellipsis
  const getPages = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 3) { start = 2; end = Math.min(maxVisible, totalPages - 1); }
      if (currentPage >= totalPages - 2) { start = Math.max(totalPages - maxVisible + 1, 2); end = totalPages - 1; }

      if (start > 2) pages.push("...");
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  const btnBase = "rounded-lg px-3 py-2 text-xs font-semibold transition";
  const btnDisabled = "bg-neutral-200 text-neutral-400 cursor-not-allowed dark:bg-neutral-800 dark:text-neutral-600";
  const btnActive = "border border-neutral-300 text-neutral-700 hover:bg-neutral-100 dark:border-neutral-700 dark:text-neutral-200 dark:hover:bg-neutral-800";

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <button
        type="button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={prevDisabled}
        className={`${btnBase} ${prevDisabled ? btnDisabled : btnActive}`}
      >
        Prev
      </button>

      {getPages().map((page, i) =>
        page === "..." ? (
          <span key={`dots-${i}`} className="px-1.5 text-xs text-neutral-400">…</span>
        ) : (
          <button
            key={page}
            type="button"
            onClick={() => onPageChange(page)}
            disabled={disabled}
            className={`${btnBase} min-w-[36px] ${
              page === currentPage
                ? "bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900"
                : btnActive
            }`}
          >
            {page}
          </button>
        )
      )}

      <button
        type="button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={nextDisabled}
        className={`${btnBase} ${nextDisabled ? btnDisabled : btnActive}`}
      >
        Next
      </button>
    </div>
  );
}
